import React, {useEffect, Suspense} from 'react';
import { Redirect, Route,Switch, useLocation} from 'react-router-dom';

const HomeContainer = React.lazy(() => import("./containers/HomeContainer"));
const DashboardContainer = React.lazy(() => import('./containers/DashboardContainer'));
const ProfileContainer = React.lazy(() => import('./containers/ProfileContainer'));
const BookingsContainer = React.lazy(() => import('./containers/BookingsContainer'));
const CatalogueContainer = React.lazy(() => import('./containers/CatalogueContainer'));
const WalletContainer = React.lazy(() => import('./containers/WalletContainer'));
const RegisterContainer = React.lazy(() => import('./containers/RegisterContainer'));
const CartContainer = React.lazy(() => import('./containers/CartContainer'));
const Login = React.lazy(() => import("./containers/Login"));
const Logout = React.lazy(() => import("./containers/Logout"));
const CreatePassword = React.lazy(() => import("./containers/CreatePassword"));
const ResetPassword = React.lazy(() => import("./containers/ResetPassword"));
const ForgotPassword = React.lazy(() => import("./containers/ForgotPassword"));
const InviteFriend = React.lazy(() => import('./containers/InviteFriend'));
const TermsConditions = React.lazy(() => import('./containers/TermsConditions'));
const LegalNotice = React.lazy(() => import('./containers/LegalNotice'));
const PrivacyPolicy = React.lazy(() => import('./containers/PrivacyPolicy'));
const SimpleHomeContainer = React.lazy(() => import('./containers/SimpleHomeContainer'));

// Fallback component while loading
const Loading = () => <div>Loading...</div>;

const PrivateRoute = ({component: Component, auth, loggedIn, ...rest}) => {
  return (
    <Route
      exact
      {...rest}
      render={props =>
        auth || loggedIn ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{
              pathname: "/",
              state: {from: props.location}
            }}
          />
        )
      }
    />
  );
}

const AppRouter = ( { auth, loggedIn }) => {
    // This hook detects the page's change. It the new location have a hash, we need to
    // jump there...
    const location = useLocation()
    useEffect(() => {
      const hash = location.hash;
      if (hash) {
        const offset = -100;
        const target = document.getElementById(hash.slice(1));
        if (target) {
          const y = target.getBoundingClientRect().top + window.pageYOffset + offset;
          window.scrollTo({ top: y, behavior: 'smooth' });
        }
      } else {
        // If not has exists, we bring the user to top.
        window.scrollTo({ top: 0 });
      }
    },[location])

    return (
        <Suspense fallback={<Loading />}>
        <Switch>
         <PrivateRoute path="/profile" component={ProfileContainer} auth={auth} loggedIn={loggedIn}/>
         <PrivateRoute path="/cart" component={CartContainer} auth={auth} loggedIn={loggedIn}/>
         <Route exact path="/bookings" component={BookingsContainer}/>
         <Route exact path="/catalogue" component={CatalogueContainer}/>
         <Route exact path="/catalogue/:hotelId" component={CatalogueContainer}/>
         <Route exact path="/wallet" component={WalletContainer}/>
         <Route exact path="/register" component={RegisterContainer}/>
         <Route exact path="/terms-conditions/:lang" component={TermsConditions}/>
         <Route exact path="/legal-notice/:lang" component={LegalNotice}/>
         <Route exact path="/privacy-policy/:lang" component={PrivacyPolicy}/>
         <Route exact path="/chain-terms-conditions/:lang" component={TermsConditions}/>
         <Route exact path="/invite-friend" component={InviteFriend}/>
         <Route path="/login" component={Login}/>
         <Route path="/logout" component={Logout}/>
         <Route path="/create-password" component={CreatePassword}/>
         <Route path="/reset-password" component={ResetPassword}/>
         <Route path="/forgot-password" component={ForgotPassword}/>
         <Route path="/dashboard" component={SimpleHomeContainer}/>
         <Route exact path="/" component={SimpleHomeContainer}/>
         <Redirect from="*" to="/"/>
        </Switch>
        </Suspense>
    );
}

export default AppRouter;
